import { render, staticRenderFns } from "./AssetApprovalRequestForm.vue?vue&type=template&id=1c4ba4dc"
import script from "./AssetApprovalRequestForm.vue?vue&type=script&lang=js"
export * from "./AssetApprovalRequestForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports